// extracted by mini-css-extract-plugin
export default {"root":"VYaek","menuCategoriesPE":"Ke0YP","container":"Oj56O","transparent":"uQiPw","mainButton":"uzKXE","mainButtonIcon":"mfQZu","mainButtonLabel":"IDx1g","userAccountPE":"aWLQI"};